import { createSelector } from "reselect"
import { get, chain } from "lodash"

const EMPTY_OBJECT = {}

const getRawConcentrationData = state => get(state, "global.data.compositeConcentration.data.model.simulation.composition", EMPTY_OBJECT)

export const getConcentrationData = createSelector(
  [getRawConcentrationData],
  (concentrationData) => chain(concentrationData)
    .map(({ date, positionsCount, concentration }) => {
      const { max, top } = concentration
      return ({
        date,
        factors: {
          positionsCount,
          maxConcentration: max / 100,
          topConcentration: top / 100,
        },
      })
    })
    .filter(data => data)
    .value(),
)

export const hasReferenceEquity = createSelector([getRawConcentrationData],
  (concentrationData) => get(concentrationData, "0.referenceEquity", null) !== null,
)
